export const SESSION_STORAGE_RESTORE_PATH_KEY = 'login:from'
